import store from "../store";
import axios from "axios";

class Notifications {

	async list_channels(channels)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/notification/channels",
				{
					channels
				}, 
				{
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.notifications);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	async list(client_uid)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/notification" + (client_uid ? "/list/" + client_uid : ""), {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.notifications);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
	async get(uid)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/notification/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.notification);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
	async delete(uid)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.delete(`${process.env.VUE_APP_SAAS_BACK}` + "/notification/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.notification);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
	async post(type, title, text, dest, active, client_uid) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/notification",
					{
						type,
						text,
						title,
						dest,
						active,
						client_uid
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}

	async put(uid, type, title, text, dest, active) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.put(
					`${process.env.VUE_APP_SAAS_BACK}` + "/notification",
					{
						uid,
						type,
						text,
						title,
						dest,
						active
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}
}

export default new Notifications();
